import { GET, POST, PUT, DELETE } from './api';

export const ReadSearchHistory = async (profileId: number | string, token: string) => {
  return await GET(`/search-histories?profile=${profileId}`, token);
};

export const AddSearchHistory = async (
  params: unknown,
  profileId: number | string,
  token: string,
) => {
  return await POST(`/search-histories?profile=${profileId}`, params, token);
};
